import * as React from "react";
import type { SVGProps } from "react";
const SvgHelp = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            d="M12 4a8 8 0 0 0-6.478 12.696 1 1 0 1 1-1.618 1.175A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.96 9.96 0 0 1-4.74-1.193 1 1 0 0 1 .949-1.76A8 8 0 1 0 12 4"
        />
        <path
            fill="currentColor"
            d="M12 8a2 2 0 0 0-2 2v1H8v-1a4 4 0 1 1 5 3.874V15h-2v-2a1 1 0 0 1 1-1 2 2 0 1 0 0-4M12 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
        />
    </svg>
);
export default SvgHelp;
